import { useParams } from "react-router-dom";
import { isLocale, localizedPath, preferredLanguage } from "./locales";

export function useLocale() {
  const { lng } = useParams();
  const locale = isLocale(lng) ? lng : preferredLanguage();
  const path = (to = "/") => localizedPath(locale, to);
  return { locale, path };
}
